/* ------------------------------------------------------------------
   Notificações do header (pa-)

   O que está por ler vive só no browser de quem visita (localStorage).
   Não há backend: limpar os dados do browser ou trocar de dispositivo faz
   o badge voltar. Foi uma limitação aceite ao desenhar a funcionalidade.

   Uma notificação conta como lida quando o painel é aberto.
   Volta a contar como por ler se:
     - o conteúdo mudou (o md5 gerado no Liquid deixa de bater certo), ou
     - passaram mais de N dias desde a leitura (N = 0 desliga esta regra).
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var STORE_KEY = 'pa_notif_read_v1';
  var DAY_MS = 86400000;

  function readState() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      /* modo privado, cookies bloqueados, JSON corrompido — tratamos como "nada lido" */
      return {};
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(state));
    } catch (e) {
      /* sem persistência disponível: a sessão funciona na mesma, só não se lembra */
    }
  }

  /* Os sinos são lidos sempre de novo, nunca guardados numa lista no arranque:
     o header sticky do tema (assets/section-header.js) é um CLONE do header,
     feito por innerHTML depois deste script correr. O sino do clone não existia
     no init e não herda listeners — por isso os eventos vão por delegação. */
  function getBells() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pa-notif-toggle]'));
  }

  function init() {
    var panel = document.querySelector('[data-pa-notif-panel]');
    if (!panel || !getBells().length) return;

    var dialog = panel.querySelector('.pa-notif__dialog');
    var listView = panel.querySelector('[data-pa-notif-list]');
    var backBtn = panel.querySelector('[data-pa-notif-back]');
    var heading = panel.querySelector('[data-pa-notif-heading]');
    var items = Array.prototype.slice.call(panel.querySelectorAll('[data-pa-notif-id]'));
    var details = Array.prototype.slice.call(panel.querySelectorAll('[data-pa-notif-detail]'));
    var resetDays = parseInt(panel.getAttribute('data-pa-notif-reset-days'), 10) || 0;
    var panelTitle = heading ? heading.textContent : '';
    var lastFocused = null;

    if (!items.length) return;

    /* ---------- estado ---------- */

    function isUnread(item, state) {
      var id = item.getAttribute('data-pa-notif-id');
      var hash = item.getAttribute('data-pa-notif-hash');
      var entry = state[id];
      if (!entry) return true;
      if (entry.h !== hash) return true;
      if (resetDays > 0 && Date.now() - (entry.t || 0) > resetDays * DAY_MS) return true;
      return false;
    }

    function paint() {
      var state = readState();
      var unread = 0;

      items.forEach(function (item) {
        var novo = isUnread(item, state);
        if (novo) unread++;
        item.classList.toggle('pa-notif__item--unread', novo && item.classList.contains('pa-notif__item'));
        item.classList.toggle('pa-notif__promo--unread', novo && item.classList.contains('pa-notif__promo'));
      });

      getBells().forEach(function (bell) {
        bell.hidden = false;
        var badge = bell.querySelector('[data-pa-notif-badge]');
        if (!badge) return;
        badge.textContent = unread ? String(unread) : '';
        badge.hidden = unread === 0;
      });
    }

    function markAllRead() {
      var state = readState();
      var now = Date.now();
      items.forEach(function (item) {
        state[item.getAttribute('data-pa-notif-id')] = {
          h: item.getAttribute('data-pa-notif-hash'),
          t: now
        };
      });
      writeState(state);

      /* Esconde o badge mas mantém os pontos visíveis nesta abertura,
         para quem está a ver perceber o que era novo. */
      getBells().forEach(function (bell) {
        var badge = bell.querySelector('[data-pa-notif-badge]');
        if (badge) badge.hidden = true;
      });
    }

    /* ---------- pré-aquecimento das imagens ----------
       As imagens nascem loading="lazy" para não pesarem no arranque da página.
       Mas o painel está hidden, por isso o browser só as ia buscar no momento
       em que ele abre — e via-se o atraso. Trocamos para eager quando o browser
       está ocioso, e imediatamente se o rato passar pelo sino, de modo a que já
       estejam em cache quando o painel abrir. */

    var aquecidas = false;

    function warmImages() {
      if (aquecidas) return;
      aquecidas = true;
      var imgs = panel.querySelectorAll('img[loading="lazy"]');
      Array.prototype.forEach.call(imgs, function (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    }

    getBells().forEach(function (bell) {
      bell.addEventListener('pointerenter', warmImages, { once: true });
      bell.addEventListener('focus', warmImages, { once: true });
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmImages, { timeout: 4000 });
    } else {
      window.setTimeout(warmImages, 2500);
    }

    /* ---------- navegação ---------- */

    function showList() {
      listView.hidden = false;
      details.forEach(function (d) { d.hidden = true; });
      if (backBtn) backBtn.hidden = true;
      if (heading) heading.textContent = panelTitle;
      panel.querySelector('.pa-notif__body').scrollTop = 0;
    }

    function showDetail(id) {
      var target = panel.querySelector('[data-pa-notif-detail="' + id + '"]');
      if (!target) return;
      listView.hidden = true;
      details.forEach(function (d) { d.hidden = d !== target; });
      if (backBtn) {
        backBtn.hidden = false;
        backBtn.focus();
      }
      panel.querySelector('.pa-notif__body').scrollTop = 0;
    }

    /* ---------- abrir / fechar ---------- */

    function positionForDesktop(bell) {
      if (window.innerWidth < 1024 || !dialog) return;
      var r = bell.getBoundingClientRect();
      dialog.style.setProperty('--pa-notif-top', Math.round(r.bottom + 12) + 'px');
      dialog.style.setProperty('--pa-notif-end', Math.max(12, Math.round(window.innerWidth - r.right - 8)) + 'px');
    }

    function open(bell) {
      lastFocused = document.activeElement;
      positionForDesktop(bell);
      panel.hidden = false;
      showList();
      markAllRead();
      getBells().forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (window.innerWidth < 1024) document.body.classList.add('pa-notif-open');
      var first = panel.querySelector('.pa-notif__close');
      if (first) first.focus();
    }

    function close() {
      panel.hidden = true;
      getBells().forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('pa-notif-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function isOpen() {
      return !panel.hidden;
    }

    /* ---------- eventos ---------- */

    document.addEventListener('click', function (e) {
      var bell = e.target.closest('[data-pa-notif-toggle]');
      if (!bell) return;
      e.preventDefault();
      if (isOpen()) { close(); } else { open(bell); }
    });

    panel.querySelectorAll('[data-pa-notif-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showList();
      });
    }

    panel.querySelectorAll('[data-pa-notif-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showDetail(btn.getAttribute('data-pa-notif-open'));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    /* fecha ao clicar fora, no desktop (o overlay é transparente lá) */
    document.addEventListener('click', function (e) {
      if (!isOpen() || window.innerWidth < 1024) return;
      if (dialog.contains(e.target)) return;
      if (e.target.closest('[data-pa-notif-toggle]')) return;
      close();
    });

    window.addEventListener('resize', function () {
      if (isOpen()) close();
    });

    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
